

  
const content = `# Encryption Limitations
The OnData encryption feature can be used to effectively protect business data that are sensitive, confidential or regulated by certain compliance rules, such as PCI and HIPAA. But it 
does come with certain limitations. Please review the details below before you apply encryption rules to your data.

## Encryption Rule Exceptions
An encryption rule can be applied to any column to encrypt the data in that column. There are a number of exceptions that a column should not be assigned any encryption rule.

- If a column does not contain any sensitive, confidential or regulated data, do not assign any encryption rule;
- If a column is an identity column with automatically generated values, do not assign any encryption rule;
- If any of your database queries use non-equality comparison operators on a column, do not assign any encryption rule to that column. For example, if you use "<", ">", and "like", 
on a column in your queries, do not encrypt that column. The equality operators such as "= (equality)" and "<> (inequality)" are allowed for an encrypted column; 
- If you need to correlate a column in one database with a column in another database, do not assign any encryption rule to those columns unless you have configured the exact same 
encryption key for both databases;

## Stored Procedures
If you use stored procedures in your databases, such stored procedures may not work as desired when some of the columns referenced in the stored procedures are encrypted. You may 
not assign an encryption rule to a column whose values are manipulated in a stored procedures. 

## Triggers
If you use triggers to automatically perform certain actions based on the values of a column exceeding certain threshold, that column should not be assigned an encryption rule.

## Constraints
If you have constraints configured for a column to limit the possible range of values, that column should not be assigned an encryption rule, or alternative you may remove the 
constraints. For example, the encrypted value of a date column can go from 1900-01-01 to 2079-06-06. If you have a constraint to limit the values for that column, you may either 
not assign an encryption rule, or remove the constraint so that the encrypted values can be considered valid.`
  
export default content;
